/**
 * @generated SignedSource<<d238d87f70fcd8e829ff476ec6b97089>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LinkStoreToSalesAppOrderFormInput = {
  orderFormId: string;
  storeMasterdataId: string;
};
export type useLinkStoreToSalesAppOrderFormMutation$variables = {
  input: LinkStoreToSalesAppOrderFormInput;
};
export type useLinkStoreToSalesAppOrderFormMutation$data = {
  readonly linkStoreToSalesAppOrderForm: {
    readonly payload: {
      readonly id: string;
    };
  };
};
export type useLinkStoreToSalesAppOrderFormMutation = {
  variables: useLinkStoreToSalesAppOrderFormMutation$variables;
  response: useLinkStoreToSalesAppOrderFormMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LinkStoreToSalesAppOrderFormPayload",
    "kind": "LinkedField",
    "name": "linkStoreToSalesAppOrderForm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OrderForm",
        "kind": "LinkedField",
        "name": "payload",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useLinkStoreToSalesAppOrderFormMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useLinkStoreToSalesAppOrderFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "eeed21fa647be3bcec7fa1da34961349",
    "id": null,
    "metadata": {},
    "name": "useLinkStoreToSalesAppOrderFormMutation",
    "operationKind": "mutation",
    "text": "mutation useLinkStoreToSalesAppOrderFormMutation(\n  $input: LinkStoreToSalesAppOrderFormInput!\n) {\n  linkStoreToSalesAppOrderForm(input: $input) {\n    payload {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3eaa161eb5bc9dbccffcefe4f01fb81b";

export default node;
